import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", fill: "none", children: /* @__PURE__ */ s.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M20 3.75a16.25 16.25 0 1 1 0 32.5 16.25 16.25 0 1 1 0-32.5M20 40a20 20 0 1 0 0-40 20 20 0 1 0 0 40m8.828-23.672c.735-.734.735-1.922 0-2.648s-1.922-.735-2.648 0l-8.672 8.672-3.672-3.672c-.734-.735-1.922-.735-2.649 0s-.734 1.922 0 2.648l5 5a1.867 1.867 0 0 0 2.649 0z"
  }
) });
export {
  l as C
};
